var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-2{fill:#0f2a6d}\r\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3",
    "data-name": "Group 3",
    transform: "translate(-5039 -993.724)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_10",
    d: "M0 0H42V42H0z",
    "data-name": "Rectangle 10",
    transform: "translate(5039 993.724)",
    style: {
      fill: "#fff"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_56374",
    "data-name": "Group 56374",
    transform: "translate(5041.318 996.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_20442",
    d: "M21.795 17.454H16.7V2.772A.772.772 0 0 0 15.928 2h-3.085a.772.772 0 0 0-.772.772v14.682H6.98a.772.772 0 0 0-.547 1.319l7.953 7.953 7.953-7.953a.772.772 0 0 0-.545-1.319z",
    className: "prefix__cls-2",
    "data-name": "Path 20442",
    transform: "translate(3.384 1.09)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_20443",
    d: "M30.36 16.772v5.408H4.09v-5.408A.772.772 0 0 0 3.318 16H1.772a.772.772 0 0 0-.772.772v6.954a1.546 1.546 0 0 0 1.546 1.546h29.36a1.546 1.546 0 0 0 1.546-1.546v-6.954a.772.772 0 0 0-.774-.772h-1.544a.772.772 0 0 0-.774.772z",
    className: "prefix__cls-2",
    "data-name": "Path 20443",
    transform: "translate(.546 8.724)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download-pdf.f1d37c932966aa9f1dc9729079ae053b.svg";
export { ForwardRef as ReactComponent };